class ShelfBundleTileController {}

const shelfBundleTileComponentDefinition = {
    bindings: {
        bundle: '<',
    },
    controller: ShelfBundleTileController,
    template: require('./shelf-bundle-tile.component.html').trim(),
};

module.exports = {
    ShelfBundleTileController,
    shelfBundleTileComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-bundle-tile.component.js